//@flow

//import type { APIresponse, rawObjectFromAPI } from "../flowTypes.js";

const ADD_ACTIVE_API_CALL = "ADD_ACTIVE_API_CALL";
const REMOVE_ACTIVE_API_CALL = "REMOVE_ACTIVE_API_CALL";
const DROP_ACTIVE_API_CALL = "DROP_ACTIVE_API_CALL";

export const addActiveApiCall = name => {
  const action = {
    type: ADD_ACTIVE_API_CALL,
    name,
  };

  return action;
};

export const removeActiveApiCall = name => {
  const action = {
    type: REMOVE_ACTIVE_API_CALL,
    name,
  };

  return action;
};

export const dropActiveApiCall = () => {
  const action = {
    type: DROP_ACTIVE_API_CALL,
  };

  return action;
};
